import React, {createRef} from 'react';
import clsx from "clsx";

export default function MultipleChoice(props) {

    const labelRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx("sendiio-form-multiple-choice-element", `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx("sendiio-form-multiple-choice-label cursor-text", data.required && 'sendiio-form-element-required')}
               format="text"
               contentEditable={true}
               suppressContentEditableWarning={true}
               onBlur={e => {

                   if(data.label !== e.currentTarget.textContent){

                       data.label = e.currentTarget.textContent;

                       updateFormData(data);

                       labelRef.current.textContent = e.currentTarget.textContent;

                   }

               }}
               dangerouslySetInnerHTML={{__html: data.label}} />

        <div className="sendiio-form-element-wrapper sendiio-form-multiple-choice-wrapper" data-component="radio">

            <div className="sendiio-form-multiple-choice-radio-wrapper">
                {data.options.map((item, index) => (
                    <span key={`form-multiple-item-${data.id}-${index}`} className="form-radio-item">
                        <input
                            type="checkbox"
                            tabIndex="-1"
                            className="form-radio"
                            id={`checkbox_${data.id}_${index}`}
                            name={`q_${data.id}`}
                            value={item} />
                        <span>
                            <div className="editor-container">
                                <label id={`label-checkbox-${data.id}-${index}`}
                                       className="inline-editor"
                                       format="text"
                                       contentEditable={true}
                                       onBlur={e => {

                                           if(e.currentTarget.textContent !== item){

                                               data.options[index] = e.currentTarget.textContent;

                                               if(data.options[index] === ''){

                                                   data.options.splice(index, 1);

                                               }

                                               updateFormData(data);

                                           }

                                       }}
                                       dangerouslySetInnerHTML={{__html: item}}/>
                            </div>
                            <button
                                onClick={e => {

                                    e.preventDefault();

                                    data.options.splice(index, 1);

                                    updateFormData(data);

                                }}
                                className="btn btn-barebone for-delete-option">×</button>
                        </span>
                    </span>
                ))}
            </div>

            <div className="sendiio-form-single-choice-actions">
                <button
                    onClick={e => {

                        e.preventDefault();

                        data.options.push(`Type option ${data.options.length + 1}`);

                        updateFormData(data);

                    }}
                    className="btn btn-barebone underline"
                >Add Option</button>
            </div>

        </div>
    </div>

}